<script setup>
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';

defineProps({
    loading: { type: Boolean, default: false },
    disabledUp: { type: Boolean, default: false },
    disabledDown: { type: Boolean, default: false }
});

const emit = defineEmits(['up', 'down']);
</script>

<template>
    <div class="sort-stepper" @click.stop>
        <button
            type="button"
            class="sort-stepper__btn"
            :disabled="loading || disabledUp"
            title="上移"
            aria-label="上移"
            @click="emit('up')"
        >
            <CaretUpOutlined />
        </button>
        <button
            type="button"
            class="sort-stepper__btn"
            :disabled="loading || disabledDown"
            title="下移"
            aria-label="下移"
            @click="emit('down')"
        >
            <CaretDownOutlined />
        </button>
    </div>
</template>

<style scoped>
.sort-stepper {
    display: inline-flex;
    flex-direction: column;
    align-items: stretch;
    width: 28px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(42, 74, 122, 0.28);
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 1px 4px rgba(42, 74, 122, 0.12);
}

.sort-stepper__btn {
    appearance: none;
    border: 0;
    margin: 0;
    padding: 0;
    height: 22px;
    display: grid;
    place-items: center;
    background: transparent;
    color: #2a4a7a;
    cursor: pointer;
    line-height: 1;
    transition: background 0.15s ease, color 0.15s ease;
}

.sort-stepper__btn + .sort-stepper__btn {
    border-top: 1px solid rgba(42, 74, 122, 0.16);
}

.sort-stepper__btn:hover:not(:disabled) {
    background: rgba(42, 74, 122, 0.1);
    color: #1a335c;
}

.sort-stepper__btn:disabled {
    cursor: default;
    color: rgba(42, 74, 122, 0.28);
}

.sort-stepper__btn :deep(.anticon) {
    font-size: 11px;
}
</style>
